<template>
    <el-dialog
        title="Snapshot"
        :visible="visible"
        @update:visible="$emit('update:visible', $event)"
      >
        <el-form ref="snapshotRequest" :model="snapshotRequest" :rules="rules">
          <el-row :gutter="20">
            <el-col :md="24" :lg="12">
              <el-form-item label="Channels" label-width="120px" prop="channels">
                <el-select
                  v-model="snapshotRequest.channels"
                  multiple
                  placeholder="Please select channels"
                >
                  <el-option
                    v-for="item in channels"
                    :key="item.id"
                    :label="item.name"
                    :value="item.channelIndex"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="snapshotRequest.error">Error: {{snapshotRequest.error}}</el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="makeSnapshot"
          >
            Make Snapshot
          </el-button>
        </span>
      </el-dialog>
</template>

<script>
import {snapshotClient} from '@api/snapshot.js'
export default {
    props: ['device', 'visible'],
    data() {
      return {
        rules: {
          channels: [
            {
              type: "array",
              required: true,
              message: "Please select channels",
              trigger: "blur"
            }
          ]
        },
        snapshotRequest: {
          channels: []
        },
        loading: false
      }
    },
    computed: {
        channels() {
          return (this.device || {channels: []}).channels;
        }
    },
    watch: {
        device() {
            this.snapshotRequest.channels = [];
            this.loading = false;
        }
    },
    methods: {
      makeSnapshot() {
        this.loading = true;
        this.$refs.snapshotRequest.validate(valid => {
          if (!valid) {
            this.loading = false;
            return;
          }
          const { channels } = this.snapshotRequest;
          const serial = this.device.serial;
          snapshotClient
            .makeSnapshot(serial, channels)
            .then(({data: {status}}) => {
                    if(serial !== this.device.serial) return;
                    this.loading = false;
                    if(status === 'FAIL') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Unable to make snapshots for requested channels'
                        });
                    } else {
                        this.$notify.success({
                            title: 'Success',
                            message: 'Snapshot request completed. Click on this message to watch the downloading proggress',
                            customClass: 'download-success-notification',
                            onClick: () => this.$router.push({ name: "viewDevice", params: { serial } })
                        });
                    }
                })
                .catch(error => {
                    if(serial !== this.device.serial) return;
                    this.loading = false;
                    if(error.response) {
                        const status = error.response.status;
                        if(status === 503) {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Unable to make snapshots because the device unavailable'
                            });
                            return;
                        }
                    }
                    this.$notify.error({
                        title: 'Error',
                        message: 'Unable to make snapshots for requested channels'
                    });
                });

        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// SnapshotDialog.vue?21fdf7fa